/** @jsxImportSource @emotion/react */
import ProjectsHeader from "components/MainComponents/Projects/ProjectsHeader";
import NewProject from "components/MainComponents/Projects/NewProject";

export default function NewProjectPage() {
    return (
    <>
      <div>      
        <ProjectsHeader setNewProject={()=> true} totalProjects={10}/>
        <NewProject setNewProject={()=> true} />       
      </div>
    </>
  );
}
